import { render, staticRenderFns } from "./ProductListPanel.vue?vue&type=template&id=2774190e&"
import script from "./ProductListPanel.vue?vue&type=script&lang=js&"
export * from "./ProductListPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports